module.exports = __webpack_public_path__ + "static/img/grzx.d25f268.png";


//////////////////
// WEBPACK FOOTER
// ./static/tutorial/grzx.png
// module id = gKDl
// module chunks = 14